import $ from 'jquery';
import { BaseView } from './views/base-view';
import { Storage } from './storage';
import Mustache from 'mustache';

const FAVORITE_DATA_KEY = 'favorite-data';

class Favorites extends BaseView {
  constructor(el) {
    super(el, {
      listTemplate: '#list-template',
      listTemplatePictureSource: '#list-template-picturesource',
      clearBtn: '.clear-favorites',
      favoritesContainer: '.favorites__list',
    });

    this._storage = new Storage();
  }

  attachLikeEvents() {
    const likeButtons = this.$el.find('.favorites__like').not('.initialized');
    if (likeButtons.length) {
      this._findFavoriteStatuses(likeButtons);
      likeButtons.click(this._updateFavoritedStatus.bind(this));
      likeButtons.addClass('initialized');
    }
  }

  async listFavorites() {
    const resultTarget = this.$dom.favoritesContainer;

    if (resultTarget.length) {
      //get array of product Uuids
      let favoriteProducts = this._getFavoritesArray();

      if (favoriteProducts.length > 0) {
        const params = {
          vehicle_id: favoriteProducts,
          limit: favoriteProducts.length,
        };

        try {
          const productResponse = await this._getProducts(params);

          //remove ads
          const products = productResponse.products.filter(product => !Object.keys(product).includes('markdown'));
          this._createProductCards(products);
          this.attachLikeEvents();
        } catch (error) {
          resultTarget.html('');
          console.log(error);
        }

        //activate clear btn
        this.$dom.clearBtn.show();
        this.$dom.clearBtn.click(this._clearFavoritesList.bind(this));
      } else {
        const list = Mustache.render(this.$dom.listTemplate.html(), {
          products: false,
        });
        resultTarget.html(list);
        this.$dom.clearBtn.hide();
      }
    }
  }

  /**
   * Update favorited counters to reflect current number
   * @param {bool} animate will the favorites star be animated or not
   */
  updateAmount(animate = false) {
    const animationClassDuration = 1000;
    // Favorites page and search page have different classes for the counter, hence the two selectors
    const counterElements = document.querySelectorAll('.favorites__counter, .search_result__favorites');
    if (counterElements.length) {
      let favoriteProducts = this._getFavoritesArray();
      for (const counterElement of counterElements) {
        counterElement.querySelector('.favorites__amount').innerHTML = favoriteProducts.length;

        // Update effect to Favorites link
        if (animate) {
          counterElement.classList.add('animation--pop');
          window.setTimeout(() => {
            counterElement.classList.remove('animation--pop');
          }, animationClassDuration);
        }
      }
    }
  }

  /**
   * If product is favorited, style button
   * @param {object} buttons jquery object
   */
  _findFavoriteStatuses(buttons) {
    let favoriteProducts = this._getFavoritesArray();

    buttons.each(function () {
      const productId = $(this).data('product').toString();
      if (productId && favoriteProducts.includes(productId)) {
        $(this).addClass('active');
      }
    });
  }

  /**
   * Create single product card and append it to the target
   * @param {array} products product details
   */
  _createProductCards(products) {
    const listTemplate = this.$dom.listTemplate;
    const resultTarget = this.$dom.favoritesContainer;

    products = products.map(product => {
      product.image = product.previewImage ? product.previewImage : null;
      product.class = 'card--product';
      return product;
    });

    const list = Mustache.render(listTemplate.html(), { products }, { pictureSource: this.$dom.listTemplatePictureSource.html() });
    resultTarget.html(list);
  }

  _updateFavoritedStatus(e) {
    e.preventDefault();
    e.stopPropagation();
    const productUuid = e.currentTarget.dataset.product.toString();
    const btn = $(e.currentTarget);

    if (productUuid) {
      let favoriteProducts = this._getFavoritesArray();
      //toggle product favorite status
      if (!favoriteProducts.includes(productUuid)) {
        favoriteProducts.push(productUuid);
        btn.addClass('active');
      } else {
        favoriteProducts = favoriteProducts.filter(item => {
          return item !== productUuid;
        });
        btn.removeClass('active');
      }
      this._updateLocalStorage(favoriteProducts);
    }

    this.updateAmount(true);
  }

  _clearFavoritesList() {
    this._storage.set(FAVORITE_DATA_KEY, '');
    if (this.$dom.favoritesContainer) {
      this.$dom.favoritesContainer.html('');
    }
    this.updateAmount();
  }

  /**
   * Only updates information stored to the local storage
   * @param {array} data, product uuid array
   */
  _updateLocalStorage(data) {
    this._storage.set(FAVORITE_DATA_KEY, JSON.stringify(data));
  }

  _getFavoritesArray() {
    const storageData = this._storage.get(FAVORITE_DATA_KEY);
    return storageData ? JSON.parse(storageData) : [];
  }

  /**
   * Get products from database
   * @param {object} params containing filters, formatting etc
   * @return {array} products details
   *
   */
  async _getProducts(params) {
    try {
      return $.ajax({
        url: '/stage-ajax/vehicle-search',
        type: 'get',
        data: params,
      });
    } catch (error) {
      console.log(error);
    }
  }
}

function init() {
  if ($('.favorites').length) {
    const favorites = new Favorites('.favorites');
    favorites.attachLikeEvents();
    favorites.listFavorites();
    favorites.updateAmount();
  }
}

export default { init, Favorites };
export { init, Favorites };
